"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _LegalConsentCheckbox = _interopRequireDefault(require("MeetingsBase/models/LegalConsentCheckbox"));

var _legalConsent = require("MeetingsBase/constants/legalConsent");

var _defaults;

var isEmptyParagraph = function isEmptyParagraph(text) {
  return !text || text === '<p></p>';
};

var defaults = (_defaults = {}, (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.IS_LEGITIMATE_INTEREST, false), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT, ''), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, (0, _immutable.List)()), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS, null), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT, ''), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, (0, _immutable.List)([new _LegalConsentCheckbox.default()])), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.PRIVACY_POLICY_TEXT, ''), (0, _defineProperty2.default)(_defaults, _legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT, ''), _defaults);

var LegalConsentOptions =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(LegalConsentOptions, _Record);

  function LegalConsentOptions() {
    (0, _classCallCheck2.default)(this, LegalConsentOptions);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LegalConsentOptions).apply(this, arguments));
  }

  (0, _createClass2.default)(LegalConsentOptions, [{
    key: "hasSubscription",
    value: function hasSubscription(id) {
      return Boolean(this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].find(function (subscription) {
        return subscription.communicationTypeId === id;
      }));
    }
  }, {
    key: "hasLegitimateInterestSubscription",
    value: function hasLegitimateInterestSubscription(id) {
      return this[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS].includes(id);
    }
  }, {
    key: "hasEmptySubscription",
    value: function hasEmptySubscription() {
      return Boolean(this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].find(function (subscription) {
        return !subscription.communicationTypeId;
      }));
    }
  }, {
    key: "getNumberOfSubscriptions",
    value: function getNumberOfSubscriptions() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].size;
    }
  }, {
    key: "getSubscriptions",
    value: function getSubscriptions() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES];
    }
  }, {
    key: "getCheckboxLabels",
    value: function getCheckboxLabels() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].map(function (checkbox) {
        return checkbox.label;
      });
    }
  }, {
    key: "convertToJSON",
    value: function convertToJSON() {
      var json = this.toJS();
      json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TEXT] = json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
      json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TYPE] = _legalConsent.IMPLICIT_PROCESSING_CONSENT_TYPE;
      /*
       * Forms saves legitimateInterestPrivacyPolicyText into privacyPolicyText
       * when isLegitimateInterest is true.
       */

      if (json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST]) {
        json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT] = json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
      }

      delete json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
      delete json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
      return json;
    }
  }, {
    key: "createdFromNull",
    value: function createdFromNull() {
      return this.equals(LegalConsentOptions.from(null));
    }
  }, {
    key: "lacksSubscriptionId",
    value: function lacksSubscriptionId() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES] && this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].first() && !this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].first()[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID] || this[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS].isEmpty();
    }
  }, {
    key: "lacksLegitimateInterestText",
    value: function lacksLegitimateInterestText() {
      return !this[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
    }
  }, {
    key: "allCheckboxesHaveLabels",
    value: function allCheckboxesHaveLabels() {
      return this[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].every(function (checkbox) {
        return !isEmptyParagraph(checkbox[_legalConsent.CHECKBOX_KEYS.LABEL]);
      });
    }
  }, {
    key: "filterEmptyConsentSubscriptions",
    value: function filterEmptyConsentSubscriptions() {
      return this.update(_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, function (checkboxes) {
        return checkboxes.filter(function (checkbox) {
          return Boolean(checkbox[_legalConsent.CHECKBOX_KEYS.COMMUNICATION_TYPE_ID]);
        });
      });
    }
  }, {
    key: "filterEmptyLegitimateInterestSubscriptions",
    value: function filterEmptyLegitimateInterestSubscriptions() {
      return this.update(_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, function (subscriptions) {
        return subscriptions.filter(function (subscription) {
          return Boolean(subscription);
        });
      });
    }
  }], [{
    key: "from",
    value: function from(json) {
      if (json) {
        var _ref;

        return new LegalConsentOptions((_ref = {}, (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.IS_LEGITIMATE_INTEREST, json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST] || false), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT, this.getLegitimateInterestText(json)), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS, this.getLegitimateInterestSubscriptions(json)), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS, json[_legalConsent.KEYS.LEGITIMATE_INTEREST_LAWFUL_BASIS] || _legalConsent.LAWFUL_BASIS_PQL), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT, json[_legalConsent.KEYS.COMMUNICATION_CONSENT_TEXT]), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES, this.getCheckboxConfig(json)), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.PRIVACY_POLICY_TEXT, json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT]), (0, _defineProperty2.default)(_ref, _legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT, this.getProcessingText(json)), _ref));
      }

      return new LegalConsentOptions();
    }
  }, {
    key: "getLegitimateInterestText",
    value: function getLegitimateInterestText(json) {
      if (json[_legalConsent.KEYS.IS_LEGITIMATE_INTEREST]) {
        return json[_legalConsent.KEYS.PRIVACY_POLICY_TEXT];
      }

      return json[_legalConsent.KEYS.LEGITIMATE_INTEREST_TEXT];
    }
  }, {
    key: "getCheckboxConfig",
    value: function getCheckboxConfig(json) {
      var checkboxConfig = json[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES];

      if (checkboxConfig && checkboxConfig.map) {
        return (0, _immutable.List)(json[_legalConsent.KEYS.COMMUNICATION_CONSENT_CHECKBOXES].map(function (checkbox) {
          return new _LegalConsentCheckbox.default(checkbox);
        }));
      }

      return (0, _immutable.List)([new _LegalConsentCheckbox.default()]);
    }
  }, {
    key: "getLegitimateInterestSubscriptions",
    value: function getLegitimateInterestSubscriptions(json) {
      var subscriptionsConfig = json[_legalConsent.KEYS.LEGITIMATE_INTEREST_SUBSCRIPTIONS];

      if (subscriptionsConfig && subscriptionsConfig.map) {
        return (0, _immutable.List)(subscriptionsConfig);
      }

      return (0, _immutable.List)();
    }
  }, {
    key: "getProcessingText",
    value: function getProcessingText(json) {
      return json[_legalConsent.FORMS_KEYS.PROCESSING_CONSENT_TEXT] || json[_legalConsent.KEYS.IMPLICIT_PROCESSING_CONSENT_TEXT];
    }
  }]);
  return LegalConsentOptions;
}((0, _immutable.Record)(defaults));

exports.default = LegalConsentOptions;
module.exports = exports.default;